import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EmptyStateComponent } from '@libs/shared/ui/empty-state/empty-state/empty-state.component';
import { IllustrationImageName } from '@libs/shared/ui/illustration-image/illustration-image.component';

@Component({
  selector: 'app-empty-expert-manager-event-notification',
  standalone: true,
  imports: [EmptyStateComponent],
  template: `
    <div class="flex flex-col items-center rounded-2xl p-4">
      <app-empty-state [imageName]="imageName" [title]="header" size="md" />
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyExpertManagerEventNotificationComponent {
  imageName = IllustrationImageName.Void;
  header = '모든 알림을 확인했어요.';
}
